import type { ClientDetail } from '../ClientDetailPage';

function formatCnpj(s: string): string {
  const d = s.replace(/\D/g, '');
  if (d.length === 14) return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  if (d.length === 11) return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  return s;
}

function formatCep(s: string | null): string {
  if (!s) return '—';
  const d = s.replace(/\D/g, '');
  return d.length === 8 ? d.replace(/(\d{5})(\d{3})/, '$1-$2') : s;
}

function formatPhone(s: string | null): string {
  if (!s) return '—';
  const d = s.replace(/\D/g, '');
  if (d.length === 11) return d.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (d.length === 10) return d.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return s;
}

export function ClientGeneralTab({ client }: { client: ClientDetail }) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card title="Identificação">
        <Row label="Razão social" value={client.razaoSocial} />
        <Row label="Nome fantasia" value={client.nomeFantasia ?? '—'} />
        <Row label="CPF/CNPJ" value={formatCnpj(client.cpfCnpj)} mono />
        <Row label="Inscrição municipal" value={client.inscricaoMunicipal ?? '—'} mono />
        <Row label="Código interno" value={client.codigoCliente ?? '—'} mono />
      </Card>

      <Card title="Contato principal">
        <Row label="Email" value={client.email ?? '—'} />
        <Row label="Telefone" value={formatPhone(client.telefone)} />
        <p className="mt-3 rounded-md bg-muted/30 p-2 text-xs text-muted-foreground">
          💡 Veja a aba <strong>Contatos</strong> para cadastrar telefones e emails adicionais (comercial,
          financeiro, suporte etc.).
        </p>
      </Card>

      <Card title="Endereço" full>
        <Row
          label="Logradouro"
          value={
            client.enderecoLogradouro
              ? `${client.enderecoLogradouro}, ${client.enderecoNumero ?? 's/n'}${client.enderecoComplemento ? ' — ' + client.enderecoComplemento : ''}`
              : '—'
          }
        />
        <Row label="Bairro" value={client.enderecoBairro ?? '—'} />
        <Row label="Cidade / UF" value={`${client.enderecoCidade} / ${client.enderecoUf}`} />
        <Row label="CEP" value={formatCep(client.enderecoCep)} mono />
      </Card>
    </div>
  );
}

function Card({
  title,
  full,
  children,
}: {
  title: string;
  full?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className={`rounded-lg border border-border bg-card p-4 ${full ? 'md:col-span-2' : ''}`}>
      <h3 className="mb-3 text-sm font-medium text-muted-foreground uppercase tracking-wider">
        {title}
      </h3>
      <dl className="space-y-2">{children}</dl>
    </div>
  );
}

function Row({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="grid grid-cols-[140px_1fr] gap-2 text-sm">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className={mono ? 'font-mono' : ''}>{value}</dd>
    </div>
  );
}
